module.exports = __webpack_public_path__ + "static/media/more.8078463d.svg";